import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { CheckboxItem } from '@innogy/common-ui/forms';
import { TrackToolStep } from '@analytics/models';
import { ScCheckboxSetFormInput } from '@innogy/sitecore-forms/models';
import type { Boxed } from 'ngrx-forms';
import { FormState, NgrxFormsModule } from 'ngrx-forms';
import { TrackValueChangeDirective } from '@analytics/events';
import { CheckboxSetComponent } from '@innogy/common-ui/forms';

@Component({
  selector: 'wl-sc-checkbox-set[control][fields][trackStep]',
  templateUrl: './sc-checkbox-set.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CheckboxSetComponent, NgrxFormsModule, TrackValueChangeDirective],
})
export class ScCheckboxSetComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<Boxed<string[]>>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScCheckboxSetFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;

  checkboxItems: CheckboxItem[] = [];

  ngOnInit() {
    this.checkboxItems = this.fields.Items.map((item) => ({
      label: item.fields.Label.value as string,
      value: item.fields.Value.value,
      tooltip: {
        description: item.fields.Tooltip.value,
      },
      trackingLabel: item.fields.TrackingLabel.value,
    }));
  }
}
